/**
 * product-grid.js
 * Product Grid View Persistence - JavaScript extracted from product-grid.liquid
 */

(function() {
  'use strict';

  const grid = document.querySelector('.product-grid');

  if (grid) {
    const currentDevice = window.innerWidth >= 750 ? 'desktop' : 'mobile';
    const storedLayout = sessionStorage.getItem(`product-grid-view-${currentDevice}`);

    if (storedLayout) {
      const options = document.querySelectorAll('input[type="radio"][name="grid"]');

      grid.setAttribute('product-grid-view', storedLayout);

      for (const option of options) {
        option.checked = option.value === storedLayout;
      }
    }
  }
})();
